

import { Component, Vue, Prop } from "vue-property-decorator"

import { calculatedValueDisplay } from "@/mixins/calculatedValueDisplay"

import vSelect from "vue-select"
import FieldPermissions from "@/components/Config/Permissions/FieldPermissions.vue"
import ColumnFormatting from "@/components/Controls/ColumnFormatting.vue"
import DataSourceSelect from "./DataSourceSelect.vue"
import DataSourceTemplate from "./DataSourceTemplate.vue"
import Numeric from "./Numeric.vue"
import DateTime from "./DateTime.vue"
import MapLocation from "./MapLocation.vue"
import ExternalLink from "./ExternalLink.vue"
import TextAreaToggleExpand from "./TextAreaToggleExpand.vue"
import { operatorsByFieldType } from "@/types/insights/operators"
import { CaseColumn } from "@/types/caseColumns"
import { DataType, dataTypeByFieldType } from "@/types/dataType"
import { maxInputLength } from "@/constants/input"
import DayOfWeekSetting from "../Config/TenantSettings/DayOfWeekSetting.vue"
import { TenantFeatures } from "@/types/tenantFeatures"
import { Getter } from "vuex-class"
import UserRole from "../CaseDetails/Users/UserRole.vue"
import { FieldTypeId } from "@/types/fieldTypes"

@Component({
	components: {
		"v-select": vSelect,
		"numeric": Numeric,
		"field-permissions": FieldPermissions,
		"data-select": DataSourceSelect,
		"data-template": DataSourceTemplate,
		"date-time": DateTime,
		"map-location": MapLocation,
		"external-link": ExternalLink,
		"text-area-expand": TextAreaToggleExpand,
		"column-formatting": ColumnFormatting,
		"day-of-week-setting": DayOfWeekSetting,
		"user-role": UserRole
	}
})
export default class FieldControl extends Vue {
	@Prop()
	fieldKey: any

	@Prop()
	item: any

	@Prop()
	field: any

	@Prop()
	value: any

	@Prop({ type: Boolean, default: true })
	state!: boolean

	@Prop({ type: Boolean, default: false })
	readonly!: boolean

	@Prop({ type: Boolean, default: false })
	forceMultiSelectOnLists!: boolean

	@Getter getIsFeatureEnabled!: (feature: TenantFeatures) => boolean

	@Getter getDarkMode!: boolean;

	/* --- Constants --- */
	private TenantFeatures = TenantFeatures

	/* --- Data --- */

	passwordVisible: boolean = false

	private get selectOptions () {
		if (typeof (this.field.options) === "function") {
			return this.field.options(this.item)
		}
		return this.field.options
	}

	private changeColumnCheck () {
		this.$emit("input", !this.value)
	}

	/** Get the label for select options */
	private get selectLabel () {
		if (this.field.selectLabel) { // TODO: Add a check to see if the label matches what's on the select options.
			return this.field.selectLabel as String
		} else return "title"
	}

	public get calculatedFieldDisplayValue () {
		return calculatedValueDisplay.methods.displayCalculatedField(this.item, this.field.extensions, this.value)
	}

	private formatLength (input: string): string {
		return String(input).substring(0, maxInputLength)
	}

	private get getCaseColumn () {
		if (this.item?.dataType) {
			var column : CaseColumn = {
				key: "DataType",
				label: "DataType",
				dataType: this.item.dataType,
				fieldDataType: dataTypeByFieldType[this.item.dataType],
				dynamicField: false,
				operators: operatorsByFieldType[this.item.dataType] // lookup datatype, get operators.
			}
			return column
		}
	}

	private get getDataCyLabel (): string {
		if (!this.field.label || this.field.label.length === 0 || this.field.label === " ") {
			return "form-field-" + this.fieldKey
		}
		// replace all instances of whitespace or '/' characters with '-'
		return "form-field-" + this.field.label.replace(/[' ']|[/]/g, "-").toLowerCase()
	}

	private get closeOnSelect () {
		return !((this.field.dataType === "list-multiple") && this.getIsFeatureEnabled(TenantFeatures.MultiSelectKeepOpen))
	}

	private get selectMultiple (): boolean {
		return this.forceMultiSelectOnLists || this.field.dataType === "list-multiple"
	}

	private shouldIncludeCalculationOptions (column: CaseColumn) {
		return column.fieldDataType === DataType.number && column.dataType === FieldTypeId.Number
	}
}

